import { element } from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { Measurement } from "../../goal_templates/classes/measurements/measurement";
import { NumericInput } from "../../goal_templates/common/components/generalUtilities";
import { LeaderBoardSelector } from "../../goal_templates/common/components/LeaderBoardSelector";

// import { InterviewGoal } from "../../classes/interview_goal_class";
// import { InterviewFormContext } from "../../hooks/InterviewFormContext";
import { TMDataContext } from "../../utils/custom_hooks/TMDataContext";
import { TemplateHandler } from "../../utils/state_handlers";
import { DefaultInitialValue } from "../common/components/defaultInitialValue";
import { IncludeLeaderboards } from "../common/components/includeLeaderboards";

export const PatientGoalObservationPreview = ({
  goal,
  goalName,
  handleGoalName,
  initialReading,
  handleInitialReading,
  setHasObservationErrors,
  goalTarget,
  handleGoalTarget,
}) => {
  const { t, DBObject } = useContext(TMDataContext);
  const [leaderboardStatus, setLeaderboardStatus] = useState(
    goal.leaderboardIncluded
  );
  const [zeroValueType, setZeroValueType] = useState<boolean>(false);
  const processInputValue = (value) => {
    if (checkDecimals(value)) {
      handleGoalTarget(value);
    }
  };

  useEffect(() => {
    if (goal.isExistingGoal())
      return handleInitialReading(String(goal.initialReading));

    if (
      DBObject.zeroValueInitialReadingMeasurements.includes(
        goal.measurementId
      ) &&
      goal.isStaticGoal()
    ) {
      setZeroValueType(true);
      handleInitialReading("0");
    } else {
      setZeroValueType(false);
    }
  }, []);

  const measurementDecimalPlaces = () => {
    if (!Measurement.findById(goal.measurementId)) return 0;
    return Measurement.findById(goal.measurementId).decimalplaces;
  };

  const handleLeaderboardSelection = (value) => {
    setLeaderboardStatus(value.target.checked);
  };

  useEffect(() => {
    goal.leaderboardIncluded = leaderboardStatus;
  }, [leaderboardStatus]);

  useEffect(() => {
    if (initialReading == null) {
      setHasObservationErrors(true);
    } else setHasObservationErrors(false);
  }, [initialReading]);

  const checkDecimals = (value) => {
    let inputScreen;

    switch (measurementDecimalPlaces()) {
      case 0:
        inputScreen = new RegExp(/^\d*(\d)?$/);
        break;
      case 1:
        inputScreen = new RegExp(/^\d*(\.\d{0,1})?$/);
        break;
      case 2:
        inputScreen = new RegExp(/^\d*(\.\d{0,2})?$/);
        break;

      default:
        inputScreen = new RegExp(/^\d*(\d)?$/);
        break;
    }
    return !!inputScreen.exec(value);
  };

  const showSchedule = () => {
    if (!goal.continuous) {
      return (
        <>
          <div className="schedule-element-preview goal-form-underline">
            {" "}
            <div className="interview-list-element-number">
              {t("views.goals.headings.start_date")}
            </div>
            <div className="interview-list-element-name">{goal.startDate}</div>
          </div>
          <div className="schedule-element-preview goal-form-underline">
            {" "}
            <div className="interview-list-element-number">
              {t("views.goals.headings.occurrences")}
            </div>
            <div className="interview-list-element-name">
              {goal.occurrenceAmount}
              {"  ("}
              {goal.occurrenceFrequency.label}
              {")"}
            </div>
          </div>
          <div className="schedule-element-preview">
            {" "}
            <div className="interview-list-element-number">
              {t("views.goals.headings.end_date")}
            </div>
            <div className="interview-list-element-name">{goal.endDate}</div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="schedule-element-preview goal-form-underline">
            {" "}
            <div className="interview-list-element-number">
              {t("views.goals.headings.start_date")}
            </div>
            <div className="interview-list-element-name">{goal.startDate}</div>
          </div>
          <div className="schedule-element-preview">
            {" "}
            <div className="interview-list-element-number">
              {t("views.goals.headings.occurrence")}
            </div>
            <div className="interview-list-element-name">
              {t("views.goals.contexts.occurrence_continuous")}
            </div>
          </div>
        </>
      );
    }
  };

  return (
    <>
      <div
        className="patient-goal-preview-row oversized-row"
        style={{ alignItems: "baseline" }}
      >
        <span className="patient-goal-preview-attribute-title">
          {" "}
          {t("views.goals.headings.name")}
        </span>
        {goal.isExistingGoal() ? (
          <span className="goal-value-preview">{goal.name}</span>
        ) : (
          <span className="goal-value-preview">
            {" "}
            <div className="goal-title-input-wrap">
              <input
                type="text"
                className="goal-title-input-field"
                autoComplete="none"
                maxLength={DBObject.configVariables.goal_name_character_limit}
                onChange={handleGoalName}
                name={t("views.goals.headings.goal_name")}
                value={goalName}
                id="goal-title-input"
              />
              <span
                className="goal-title-character-count"
                style={{ float: "right" }}
              >
                {goalName.length}/
                {DBObject.configVariables.goal_name_character_limit}
              </span>
            </div>
          </span>
        )}
      </div>
      <div className="patient-goal-preview-row">
        <span className="patient-goal-preview-attribute-title">
          {" "}
          {t("views.goals.headings.type")}
        </span>
        <span className="goal-value-preview">{goal.type.label}</span>
      </div>
      <div className="patient-goal-preview-row">
        <span className="patient-goal-preview-attribute-title">
          {" "}
          {t("views.goals.headings.description")}
        </span>
        <span className="goal-value-preview" style={{ maxWidth: "400px" }}>
          {goal.description == ""
            ? t("views.goals.contexts.no_description")
            : goal.description}
        </span>
      </div>
      <div className="patient-goal-preview-row">
        <span className="patient-goal-preview-attribute-title">
          {t("views.goals.headings.measurement_type")}
        </span>
        <span className="goal-value-preview">
          {goal.measurement.labelWithUnits()}
        </span>
      </div>
      <div className="patient-goal-preview-row">
        <span className="patient-goal-preview-attribute-title">
          {t("views.goals.headings.initial_reading")}
        </span>
        {goal.isExistingGoal() ? (
          <span className="goal-value-preview">
            {goal.initialReading}&nbsp;&nbsp;
            {`${goal.measurement.unitsOnly()}`}
          </span>
        ) : !zeroValueType ? (
          <DefaultInitialValue
            checkDecimals={checkDecimals}
            goal={goal}
            initialReading={initialReading}
            handleInitialReading={handleInitialReading}
          />
        ) : (
          <div className="goal-form-radio-button-wrapper stacked-options">
            <span style={{ marginBottom: "0px" }}>
              {t(
                "views.goals.contexts.Observation.initial_reading_from_system"
              )}
            </span>
          </div>
        )}
      </div>
      <div
        className="patient-goal-preview-row"
        style={{ alignItems: "baseline" }}
      >
        <span className="patient-goal-preview-attribute-title">
          {" "}
          {t("views.goals.headings.target")}
        </span>
        <span className="goal-value-preview">
          {goal.isExistingGoal() ? (
            goal.achievementTarget
          ) : (
            <NumericInput
              id={`goal-template-${goal.templateId}-measurement-value`}
              handleValue={processInputValue}
              state={goalTarget == null ? "" : goalTarget}
            />
          )}
          &nbsp;&nbsp;
          {`${goal.measurement.unitsOnly()}`}
        </span>
      </div>
      <div className="patient-goal-preview-row">
        <span className="patient-goal-preview-attribute-title">
          {t("views.goals.headings.achievement")}
        </span>
        <span className="goal-value-preview">
          {t(
            `views.goals.contexts.${goal.type.label}.achievement_status_start`
          )}{" "}
          <span className="goal-variables-preview">
            {goal.achievementCondition.label}
          </span>{" "}
          {t(`views.goals.contexts.${goal.type.label}.status_end`)}{" "}
          <span className="goal-variables-preview">
            {goalTarget}
            {goal.measurement.unitsOnly()}
          </span>
        </span>
      </div>
      <div className="patient-goal-preview-row">
        <span className="patient-goal-preview-attribute-title">
          {t("views.goals.headings.threshold")}
        </span>
        <span className="goal-value-preview">{goal.achievementThreshold}%</span>
      </div>
      <div className="patient-goal-preview-row">
        <span className="patient-goal-preview-attribute-title">
          {t("views.goals.headings.schedule")}
        </span>
        <span className="patient-goal-preview-list">{showSchedule()}</span>
      </div>
      {DBObject.configVariables.leaderboards_enabled == "true" &&
      goal.hasLeaderboardsEnabled() ? (
        <div className="patient-goal-preview-row">
          <span className="patient-goal-preview-attribute-title">
            {t("views.goals.headings.leaderboard")}
          </span>
          {goal.isExistingGoal() ? (
            goal.leaderboardIncluded ? (
              t("views.goals.contexts.Leaderboard.included")
            ) : (
              t("views.goals.contexts.Leaderboard.excluded")
            )
          ) : (
            <IncludeLeaderboards
              handleLeaderboardSelection={handleLeaderboardSelection}
              leaderboardStatus={leaderboardStatus}
            />
          )}
        </div>
      ) : null}
    </>
  );
};
